import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d48b9d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.$localize('')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileStore.bufferProfile.workplaces, (workplace, idx) => {
      return (_openBlock(), _createBlock(_component_Form, {
        as: "el-form",
        "validation-schema": _ctx.schema,
        key: idx
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_input, {
            modelValue: workplace.name,
            "onUpdate:modelValue": ($event: any) => ((workplace.name) = $event),
            name: "name",
            label: _ctx.$localize('profile.edit.workplace.name'),
            placeholder: _ctx.$localize('profile.edit.workplace.add.name')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder"]),
          _createVNode(_component_app_input, {
            modelValue: workplace.street,
            "onUpdate:modelValue": ($event: any) => ((workplace.street) = $event),
            name: "street",
            label: _ctx.$localize('profile.edit.workplace.street'),
            placeholder: _ctx.$localize('profile.edit.workplace.add.street')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder"]),
          _createVNode(_component_app_input, {
            modelValue: workplace.city,
            "onUpdate:modelValue": ($event: any) => ((workplace.city) = $event),
            name: "city",
            label: _ctx.$localize('profile.edit.workplace.city'),
            placeholder: _ctx.$localize('profile.edit.workplace.add.city')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_app_select, {
              class: "mr-10",
              modelValue: workplace.state,
              "onUpdate:modelValue": ($event: any) => ((workplace.state) = $event),
              name: "state",
              label: _ctx.$localize('profile.edit.workplace.state'),
              placeholder: _ctx.$localize('profile.edit.workplace.add.state'),
              options: _ctx.mainStore.states
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder", "options"]),
            _hoisted_2,
            _createVNode(_component_app_input, {
              modelValue: workplace.zipCode,
              "onUpdate:modelValue": ($event: any) => ((workplace.zipCode) = $event),
              name: "zipCode",
              inputmode: "numeric",
              label: _ctx.$localize('profile.edit.workplace.zip'),
              placeholder: _ctx.$localize('profile.edit.workplace.add.zip')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder"])
          ])
        ]),
        _: 2
      }, 1032, ["validation-schema"]))
    }), 128)),
    (_ctx.isWorkplaceFilled)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addWorkplace && _ctx.addWorkplace(...args)))
        }, _toDisplayString(_ctx.$localize('profile.edit.workplace.button.add')), 1))
      : _createCommentVNode("", true)
  ], 64))
}